var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRiskchecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79641 9.4305C4.79582 8.48358 5.08046 7.55844 5.61324 6.77563C6.38473 5.63971 7.63738 4.8562 9.07633 4.71942C8.98888 3.93339 8.40489 3.29527 7.64605 3.12402C5.34221 3.81267 3.56443 5.73336 3.08035 8.11846C2.90453 8.9844 2.90453 9.87685 3.08035 10.7428C3.66555 13.6268 6.1443 15.8321 9.15899 15.9997L7.58692 13.7451C5.9434 13.0032 4.79641 11.3487 4.79641 9.4305Z",
    fill: "url(#paint0_linear_3596_4723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2472 9.07876L15.8218 7.50417C15.3931 6.10335 14.5073 4.90096 13.3406 4.06934C13.3807 4.35382 13.4008 4.64074 13.401 4.92803C13.4012 5.44337 13.3362 5.95668 13.2075 6.4557C13.7973 7.18394 14.1755 8.08949 14.2472 9.07876Z",
    fill: "url(#paint1_linear_3596_4723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4371 13.1625C12.1106 13.417 11.7524 13.6278 11.3714 13.7896L8.51205 9.68958C10.4425 9.17458 11.9086 7.51265 12.1365 5.48231C12.2217 4.74101 12.1362 3.99005 11.8864 3.28692C11.2088 1.37369 9.3818 0 7.24061 0H0V15.9998H1.84797V1.84797H7.24048C8.13844 1.84797 8.94787 2.23485 9.51226 2.84957C9.97794 3.35964 10.2774 4.02736 10.3168 4.76287C10.3192 4.81706 10.3204 4.87252 10.3204 4.92791C10.3204 6.59357 8.99113 7.95493 7.3378 8.00545C7.30574 8.00792 6.37559 8.00792 6.37559 8.00792V9.85589L10.6061 15.9222C11.6553 15.7482 12.6464 15.3216 13.4939 14.6791C14.0958 14.2232 14.6154 13.6678 15.0302 13.0368L13.6836 11.6915C13.3734 12.2622 12.9491 12.7629 12.4371 13.1625Z",
    fill: "url(#paint2_linear_3596_4723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3596_4723",
    x1: 2.94849,
    y1: 3.7678,
    x2: 10.3857,
    y2: 4.56571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BB4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3596_4723",
    x1: 13.2075,
    y1: 4.31981,
    x2: 16.3321,
    y2: 4.6825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BB4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3596_4723",
    x1: 1.3606e-7,
    y1: 0.799988,
    x2: 17.4445,
    y2: 4.44494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BB4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRiskchecker);
export default __webpack_public_path__ + "static/media/chatRiskchecker.228260bb567d5d0c64352c24a246a367.svg";
export { ForwardRef as ReactComponent };